import { profileConstants as pc } from 'srcReact/MyProfile/constant'
import { profileService } from 'srcReact/services'
import { commonActions } from 'srcReact/components'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { alertActions } from 'srcReact/Alert'

export const profileActions = {
  setUserType,
  getProfileDetails,
  putProfileDetails,
  setLanguagePopup,
  setExperiencePopup,
  getUserExperience,
  setProfilePopup,
  setEducationPopup,
  addUserExperience,
  updateUserExperience,
  deleteUserExperience,
  putInterest,
  addInterest,
  removeInterests,
  setCropper,
  putProfilePicture,
  clearProfilePictureUpdateData,
  putProfilePopup,
  setUserId,
  setInitial,
  clearData,
  getUserEducation,
  addUserEducation,
  updateUserEducation,
  deleteUserEducation,
  resetExperiencePopup,
  resetEducationPopup,
  getExpertiseList,
  updateExpertise,
  saveCoverPicture,
  getPromptList,
  addPrompt,
  updatePrompt,
  deletePrompt,
  likeOrDislikePrompt,
  clearInterestUpdate
}

function setInitial() {
  return {
    type: pc.INITIAL_STATE
  }
}

function clearData() {
  return {
    type: pc.CLEAR_DATA
  }
}

function clearInterestUpdate() {
  return {
    type: pc.CLEAR_INTEREST_UPDATE
  }
}

function setUserType() {
  return {
    type: pc.SET_USER_TYPE
  }
}

function setLanguagePopup(value) {
  return {
    type: pc.SET_LANGUAGE_POPUP,
    value
  }
}

function setExperiencePopup(value) {
  return {
    type: pc.SET_EXPERIENCE_POPUP,
    value
  }
}

function setProfilePopup(value) {
  return {
    type: pc.SET_PROFILE_POPUP,
    value
  }
}

function setEducationPopup(value) {
  return {
    type: pc.SET_EDUCATION_POPUP,
    value
  }
}

function setCropper(value) {
  return {
    type: pc.SET_IMAGE_CROPPER,
    value
  }
}

function setUserId(value) {
  return {
    type: pc.SET_USER_ID,
    value
  }
}

function getProfileDetails(payload) {
  return (dispatch) => {
    dispatch(request())

    profileService.getProfileDetails(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.GET_MY_PROFILE_REQUEST }
  }
  function success(response) {
    return { type: pc.GET_MY_PROFILE_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.GET_MY_PROFILE_FAILURE, error }
  }
}

function putProfileDetails(key, value, ctaPopup) {
  return (dispatch) => {
    dispatch(request())

    profileService.putProfileDetails(key, value, ctaPopup).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
        dispatch(alertActions.error(error))
      }
    )
  }

  function request() {
    return { type: pc.PUT_MY_PROFILE_REQUEST }
  }
  function success(response) {
    return { type: pc.PUT_MY_PROFILE_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.PUT_MY_PROFILE_FAILURE, error }
  }
}

function getUserExperience(payload) {
  return (dispatch) => {
    dispatch(request())

    profileService.getUserExperience(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.GET_USER_EXPERIENCE_REQUEST }
  }
  function success(response) {
    return { type: pc.GET_USER_EXPERIENCE_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.GET_USER_EXPERIENCE_FAILURE, error }
  }
}

function addUserExperience(organization, role, startDate, endDate, ctaPopup) {
  return (dispatch) => {
    dispatch(request())

    profileService.addUserExperience(organization, role, startDate, endDate, ctaPopup).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.ADD_USER_EXPERIENCE_REQUEST }
  }
  function success(response) {
    return { type: pc.ADD_USER_EXPERIENCE_SUCCESS, response, actionType: 'add' }
  }
  function failure(error) {
    return { type: pc.ADD_USER_EXPERIENCE_FAILURE, error }
  }
}

function updateUserExperience(experienceId, organization, role, startDate, endDate, ctaPopup) {
  return (dispatch) => {
    dispatch(request())

    profileService.updateUserExperience(experienceId, organization, role, startDate, endDate, ctaPopup).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.UPDATE_USER_EXPERIENCE_REQUEST }
  }
  function success(response) {
    return { type: pc.UPDATE_USER_EXPERIENCE_SUCCESS, response, actionType: 'update' }
  }
  function failure(error) {
    return { type: pc.UPDATE_USER_EXPERIENCE_FAILURE, error }
  }
}

function deleteUserExperience(payload) {
  return (dispatch) => {
    dispatch(request())

    profileService.deleteUserExperience(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.DELETE_USER_EXPERIENCE_REQUEST }
  }
  function success(response) {
    return { type: pc.DELETE_USER_EXPERIENCE_SUCCESS, response, actionType: 'delete' }
  }
  function failure(error) {
    return { type: pc.DELETE_USER_EXPERIENCE_FAILURE, error }
  }
}

function putInterest(interestIds, ctaPopup) {
  return (dispatch) => {
    dispatch(request())

    profileService.putInterest(interestIds, ctaPopup).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.PUT_INTEREST_REQUEST }
  }
  function success(response) {
    return { type: pc.PUT_INTEREST_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.PUT_INTEREST_FAILURE, error }
  }
}

function addInterest(interestIds) {
  return (dispatch) => {
    dispatch(request())

    profileService.addInterest(interestIds).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.ADD_INTEREST_REQUEST }
  }
  function success(response) {
    return { type: pc.ADD_INTEREST_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.ADD_INTEREST_FAILURE, error }
  }
}

function removeInterests(interestIds) {
  return (dispatch) => {
    dispatch(request())

    profileService.removeInterests(interestIds).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.REMOVE_INTEREST_REQUEST }
  }
  function success(response) {
    return { type: pc.REMOVE_INTEREST_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.REMOVE_INTEREST_FAILURE, error }
  }
}

function putProfilePicture(pictureId, organizationId, ctaPopup) {
  return (dispatch) => {
    dispatch(request())

    profileService.putProfilePicture(pictureId, organizationId, ctaPopup).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.PUT_PROFILE_PICTURE_REQUEST }
  }
  function success(response) {
    return { type: pc.PUT_PROFILE_PICTURE_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.PUT_PROFILE_PICTURE_FAILURE, error }
  }
}

function clearProfilePictureUpdateData() {
  return { type: pc.CLEAR_PICTURE_UPDATE_DATA }
}

function putProfilePopup(payload) {
  return (dispatch) => {
    dispatch(request())

    profileService.putProfilePopup(payload).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.PUT_PROFILE_POPUP_REQUEST }
  }
  function success(response) {
    return { type: pc.PUT_PROFILE_POPUP_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.PUT_PROFILE_POPUP_FAILURE, error }
  }
}

function getUserEducation(payload) {
  return (dispatch) => {
    dispatch(request())

    profileService.getUserEducation(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.GET_USER_EDUCATION_REQUEST }
  }
  function success(response) {
    return { type: pc.GET_USER_EDUCATION_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.GET_USER_EDUCATION_FAILURE, error }
  }
}

function addUserEducation(payload) {
  return (dispatch) => {
    dispatch(request())

    profileService.addUserEducation(payload).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.ADD_USER_EDUCATION_REQUEST }
  }
  function success(response) {
    return { type: pc.ADD_USER_EDUCATION_SUCCESS, response, actionType: 'add' }
  }
  function failure(error) {
    return { type: pc.ADD_USER_EDUCATION_FAILURE, error }
  }
}

function updateUserEducation(payload) {
  return (dispatch) => {
    dispatch(request())

    profileService.updateUserEducation(payload).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.UPDATE_USER_EDUCATION_REQUEST }
  }
  function success(response) {
    return { type: pc.UPDATE_USER_EDUCATION_SUCCESS, response, actionType: 'update' }
  }
  function failure(error) {
    return { type: pc.UPDATE_USER_EDUCATION_FAILURE, error }
  }
}

function deleteUserEducation(payload) {
  return (dispatch) => {
    dispatch(request())

    profileService.deleteUserEducation(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.DELETE_USER_EDUCATION_REQUEST }
  }
  function success(response) {
    return { type: pc.DELETE_USER_EDUCATION_SUCCESS, response, actionType: 'delete' }
  }
  function failure(error) {
    return { type: pc.DELETE_USER_EDUCATION_FAILURE, error }
  }
}

function getExpertiseList(payload) {
  return profileService.getExpertiseList({ ...payload, quantity: appConstantSettings.PAGINATION_QUANTITY })
}

function updateExpertise(ids, ctaPopup) {
  return (dispatch) => {
    dispatch(request())

    profileService.updateExpertise(ids, ctaPopup).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.UPDATE_EXPERTISE_REQUEST }
  }
  function success(response) {
    return { type: pc.UPDATE_EXPERTISE_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.UPDATE_EXPERTISE_FAILURE, error }
  }
}

function resetExperiencePopup() {
  return {
    type: pc.RESET_EXPERIENCE_POPUP_DATA
  }
}

function resetEducationPopup() {
  return {
    type: pc.RESET_EDUCATION_POPUP_DATA
  }
}

function saveCoverPicture(pictureId, organizationId) {
  return (dispatch) => {
    dispatch(request())

    profileService.saveCoverPicture(pictureId, organizationId).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.SAVE_COVER_PICTURE_REQUEST }
  }
  function success(response) {
    return { type: pc.SAVE_COVER_PICTURE_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.SAVE_COVER_PICTURE_FAILURE, error }
  }
}

function getPromptList() {
  return (dispatch) => {
    dispatch(request())

    profileService.getPromptList().then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: pc.GET_PROMPT_LIST_REQUEST }
  }
  function success(data) {
    return { type: pc.GET_PROMPT_LIST_SUCCESS, data }
  }
  function failure(error) {
    return { type: pc.GET_PROMPT_LIST_FAILURE, error }
  }
}

function addPrompt(id_prompt, answer, ctaPopup) {
  return (dispatch) => {
    dispatch(request({ id_prompt, answer }))

    profileService.addPrompt(id_prompt, answer, ctaPopup).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: pc.ADD_PROMPT_REQUEST, data }
  }
  function success(data) {
    return { type: pc.ADD_PROMPT_SUCCESS, data }
  }
  function failure(error) {
    return { type: pc.ADD_PROMPT_FAILURE, error }
  }
}

function updatePrompt(id_prompt_user, answer, ctaPopup) {
  return (dispatch) => {
    dispatch(request({ id_prompt_user, answer }))

    profileService.updatePrompt(id_prompt_user, answer, ctaPopup).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: pc.UPDATE_PROMPT_REQUEST, data }
  }
  function success(data) {
    return { type: pc.UPDATE_PROMPT_SUCCESS, data }
  }
  function failure(error) {
    return { type: pc.UPDATE_PROMPT_FAILURE, error }
  }
}

function deletePrompt(id_prompt_user, prompt_id) {
  return (dispatch) => {
    dispatch(request({ id_prompt_user, prompt_id }))

    profileService.deletePrompt({ id_prompt_user }).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: pc.DELETE_PROMPT_REQUEST, data }
  }
  function success(data) {
    return { type: pc.DELETE_PROMPT_SUCCESS, data, prompt_id }
  }
  function failure(error) {
    return { type: pc.DELETE_PROMPT_FAILURE, error }
  }
}

function likeOrDislikePrompt(id_prompt_user, action, prompt_id) {
  return (dispatch) => {
    dispatch(request({ id_prompt_user, action, prompt_id }))

    profileService.likeOrDislikePrompt({ id_prompt_user, action }).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: pc.LIKE_OR_DISLIKE_PROMPT_REQUEST, data }
  }
  function success(data) {
    return { type: pc.LIKE_OR_DISLIKE_PROMPT_SUCCESS, data, prompt_id }
  }
  function failure(error) {
    return { type: pc.LIKE_OR_DISLIKE_PROMPT_FAILURE, error }
  }
}
